import * as React from 'react'

import type { VariantProps } from 'cva'
import { cva } from 'cva'

import { ExclamationCircleSolid } from '@/components/icons'

import { cn } from '@/libs/cn'

const hintVariants = cva({
  base: 'txt-small',
  variants: {
    variant: {
      info: 'text-ui-fg-subtle',
      error: 'text-ui-fg-error grid grid-cols-[20px_1fr] items-start gap-1',
    },
  },
  defaultVariants: {
    variant: 'info',
  },
})

interface HintProps
  extends VariantProps<typeof hintVariants>,
    React.ComponentPropsWithoutRef<'span'> {}

const Hint = React.forwardRef<HTMLSpanElement, HintProps>(
  (
    {
      className,
      /**
       * The hint's style.
       */
      variant = 'info',
      children,
      ...props
    }: HintProps,
    ref
  ) => {
    return (
      <span ref={ref} className={cn(hintVariants({ variant }), className)} {...props}>
        {variant === 'error' && (
          <div className="flex size-5 items-center justify-center">
            <ExclamationCircleSolid />
          </div>
        )}
        {children}
      </span>
    )
  }
)
Hint.displayName = 'Hint'

export { Hint }
